import React, { useState } from 'react'
import { IconButton, Menu, MenuItem, BoxProps } from '@mui/material'
import { AvatarIcon } from '../../styles/Icons.styled'
import { useAtom } from 'jotai'
import { userAtom } from '../../../state/userAtom'
import { UsernameContainer } from './UserSection.styled'
import { useAuth } from '../../../hooks/useAuth'
import withCapabilities from '../../../hoc/withCapabilities'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MenuItem as MenuItemType } from '../../../types/menuItem.types'
import { LogoutIcon } from '../../styles/Icons.styled'
import { BodyText } from '../../styles/Typography.styled'

interface UserSectionProps extends BoxProps {
  items: MenuItemType[]
}
const UserSection: React.FC<UserSectionProps> = ({ items, ...props }) => {
  const [user] = useAtom(userAtom)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const { logout } = useAuth()

  return (
    <UsernameContainer {...props}>
      {/* ----------------------------- Avatar ----------------------------- */}
      <IconButton onClick={handleMenu} color="secondary">
        <AvatarIcon />
      </IconButton>

      {/* ----------------------------- Username ----------------------------- */}
      <BodyText color="secondary.main" sx={{ marginLeft: 1 }}>
        {user?.firstName} {user?.lastName}
      </BodyText>

      {/* ----------------------------- MOBILE Menu ----------------------------- */}
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* ----------------------------- Menu Items ----------------------------- */}
        {items.map((item) => (
          <MenuItem
            key={item.url}
            onClick={() => {
              navigate(item.url)
              handleClose()
            }}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 2 }}
          >
            {React.cloneElement(item.icon, {
              customColor: 'text.primary',
              size: '25px',
            })}
            <BodyText>{item.label}</BodyText>
          </MenuItem>
        ))}

        {/* ----------------------------- Logout ----------------------------- */}
        <MenuItem
          onClick={() => {
            logout()
            handleClose()
          }}
          key="logout"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 2 }}
        >
          <LogoutIcon customColor="text.primary" size="25px" />
          <BodyText>{t('header.logout')}</BodyText>
        </MenuItem>
      </Menu>
    </UsernameContainer>
  )
}

export default withCapabilities(UserSection)
